var React = require('react');

function CheckInCircle (props) {
    return React.createElement("svg",props,[React.createElement("path",{"fill":"#C5EAEA","d":"M0 8a8 8 0 1 1 16 0A8 8 0 1 1 0 8Z","key":0}),React.createElement("path",{"fill":"#067D7D","d":"M7.033 9.41 4.758 7.028 4 7.822 7.033 11 12 5.795 11.242 5l-4.21 4.41Z","key":1})]);
}

CheckInCircle.defaultProps = {"fill":"none","viewBox":"0 0 16 16"};

module.exports = CheckInCircle;

CheckInCircle.default = CheckInCircle;
